import $axios from "../api/accessor";
import { $api } from "../api/api";

const _v = Date.now();

export const SiteService = {
  async GetSiteTranslation() {
    let response = await $axios
      .get($api("get_siteTranslationData"), { params: { _v } })
      .catch((err) => {
        return err.response;
      });
    return {
      data: response?.data ? response?.data : [],
      status: response?.status,
    };
  },
};
